import React, {FC} from "react"

import Flex from "@irati/ui/src/Flex"
import {H3} from "@irati/ui/src/Typography"
import {useTheme} from "@irati/ui/src/global/useTheme"
import FormattedMessage, {useIntl} from "@irati/utils/lang"
import Spacing from "@irati/ui/src/Spacing"

import {Background, StyledCard} from "./styled"

interface Props {}

const LoginBackground: FC<Props> = ({children}) => {
  const theme = useTheme()
  const {formatMessage} = useIntl()

  return (
    <Background>
      <Flex alignItems="center" direction="column" maxWidth="820px" margin="0 auto">
        <Spacing marginTop={2}>
          <img width="175px" src={formatMessage({id: "platform.oneTimePassword.header.img"})} alt="" />
        </Spacing>
        <H3 marginTop={2} color={theme.colors.greys.white}>
          <FormattedMessage id="platform.oneTimePassword.header.title" />
        </H3>
        <StyledCard margin={3}>{children}</StyledCard>
      </Flex>
    </Background>
  )
}

export default LoginBackground
